import {useEditor} from "@grapesjs/react";
import cx from '../../../app/editor/utils/makeCls'
import Accordion from "../Accordion";
import Grid from "../Grid";
import GridItem from "../GridItem";
import {br, cl, fx, pad} from '../theme';
import PropertyLabel from "./PropertyLabel";
import SectorBackground from "./SectorBackground";
import SectorBorders from "./SectorBorders";
import SectorSize from "./SectorSize";
import SectorSpace from "./SectorSpace";
import SectorTypography from "./SectorTypography";
import {colord} from "colord";
import SectorPosition from "./SectorPosition";

export const getOptions = (prop, labelOpts) => {
    return prop.getOptions().map((opt) => ({
        id: prop.getOptionId(opt),
        label: prop.getOptionLabel(prop.getOptionId(opt), labelOpts),
        title: opt.title,
    }))
}

export const toOptionsWithTitle = (prop, options) => {
    return options.map(opt => ({
        ...opt,
        title: prop.getOptionLabel(prop.getOptionId(opt)),
    }));
}

export const getButtonsProps = (prop, labelOpts) => {
    return {
        size: 's',
        options: getOptions(prop, labelOpts),
        value: prop.getValue(),
        onChange: (value) => prop.upValue(value),
    }
}

export const getStackProps = (prop, newLayer = {}) => {
    return {
        title: prop.getLabel(),
        titleAdd: `Add new ${prop.getLabel()}`,
        items: prop.getLayers(),
        selected: prop.getSelectedLayer(),
        renderItem: (layer) => prop.getLayerLabel(layer),
        add: () => prop.addLayer(newLayer, {at: 0}),
        select: (layer) => prop.selectLayer(layer),
        remove: (layer) => prop.removeLayer(layer),
        move: (layer, index = 0) => prop.moveLayer(layer, index),
        label: <PropertyLabel property={prop}/>,
    }
}

export const getNumberProps = (prop) => {
    return {
        size: 's',
        value: prop.getValue({noDefault: true}),
        valueUnit: prop.getUnit(),
        units: prop.getUnits(),
        placeholder: prop.getDefaultValue(),
        onChangeUnit: (unit) => prop.upUnit(unit),
        onChange: (value, partial) => prop.upValue(value, {partial}),
    }
}

export const getSliderProps = (prop) => {
    return {
        value: prop.getValue(),
        units: prop.getUnits(),
        placeholder: prop.getDefaultValue(),
        min: prop.getMin(),
        max: prop.getMax(),
        step: prop.getStep(),
        onChange: (value, partial) => prop.upValue(value, {partial})
    }
}

export const getColorProps = (prop) => {
    return {
        size: 's',
        value: colord(prop.getValue({noDefault: true})).toHex(),
        placeholder: prop.getDefaultValue(),
        onChange: (value, partial) => prop.upValue(value, {partial}),
    }
}

export default function StyleManager({className, sectors}) {
    const {Styles} = useEditor();
    const target = Styles.getSelected();
    const sectorsPatch = sectors.length ? sectors : Styles.getSectors({visible: true});
    return (
        !target ? <GridItem className="text-center fs_ss custom_text_style">{"변경할 영역을 선택해 주세요"}</GridItem> :
            <div className={cx(className, 'select-none')}>
                {
                    sectorsPatch.map((sector, index) =>
                        <Accordion key={sector.getId()} sticky
                                   handler={() => {
                                       const hasValue = sector.getProperties({withValue: true}).length > 0;
                                       const hasValueP = sector.getProperties({withParentValue: true}).length > 0;
                                       return (
                                           <Grid space="xs" items="center">
                                               <GridItem className="mr-2">
                                                   {sector.getName()}
                                               </GridItem>
                                               {
                                                   hasValue &&
                                                   <GridItem>
                                                       <div className={cx(fx.dot, cl.bgA2)}/>
                                                   </GridItem>
                                               }
                                               {
                                                   hasValueP &&
                                                   <GridItem>
                                                       <div className={cx(fx.dot, cl.bgW)}/>
                                                   </GridItem>
                                               }
                                           </Grid>
                                       )
                                   }}
                                   className={(open) => cx(
                                       cl.bgH2,
                                       pad.xyS,
                                       cl.br,
                                       index && br.bt,
                                       (open || index === sectorsPatch.length - 1) && br.bb
                                   )}>
                            <Grid className="p-2" col>
                                {/*{sector.getId() === 'layout' && <SectorLayout sector={sector}/>}*/}
                                {sector.getId() === 'size' && <SectorSize sector={sector}/>}
                                {sector.getId() === 'space' && <SectorSpace sector={sector}/>}
                                {sector.getId() === 'position' && <SectorPosition sector={sector}/>}
                                {/*{sector.getId() === 'effects' && <SectorEffects sector={sector}/>}*/}
                                {sector.getId() === 'typography' && <SectorTypography sector={sector}/>}
                                {sector.getId() === 'background' && <SectorBackground sector={sector}/>}
                                {sector.getId() === 'borders' && <SectorBorders sector={sector}/>}
                            </Grid>
                        </Accordion>
                    )
                }
            </div>
    );
}